// Getters
export const GET_AGREEMENTS = "agreements/GET_AGREEMENTS";
export const GET_AGREEMENT = "agreements/GET_AGREEMENT";

// Mutations
export const MUTATE_LOAD_AGREEMENTS = "agreements/MUTATE_LOAD_AGREEMENTS";
export const MUTATE_ADD_AGREEMENT = "agreements/MUTATE_ADD_AGREEMENT";
export const MUTATE_UPDATE_AGREEMENT = "agreements/MUTATE_UPDATE_AGREEMENT";
export const MUTATE_DELETE_AGREEMENT = "agreements/MUTATE_DELETE_AGREEMENT";

// Actions
export const ACTION_GET_AGREEMENTS = "agreements/ACTION_GET_AGREEMENTS";
export const ACTION_GET_AGREEMENT = "agreements/ACTION_GET_AGREEMENT";
export const ACTION_ADD_AGREEMENT = "agreements/ACTION_ADD_AGREEMENT";
export const ACTION_UPDATE_AGREEMENT = "agreements/ACTION_UPDATE_AGREEMENT";
export const ACTION_DELETE_AGREEMENT = "agreements/ACTION_DELETE_AGREEMENT";